var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"elevation-2 pa-5 home-img"},[_c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":"Shipping & Logistic Lead Time Flow","contain":"","src":require("@/assets/home.png")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }